import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Copy, Share2, Mail, MessageCircle, Check, Gift, Users, Sparkles } from 'lucide-react';

const ReferFriendPage = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const referralCode = 'NEARU-VIP-2024';
  const referralLink = `https://nearu.app/join/${referralCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Join Near U',
          text: 'Join me on Near U - the exclusive luxury social network!',
          url: referralLink
        });
      } catch (err) {
        console.log('Share cancelled');
      }
    } else {
      handleCopy();
    }
  };

  const handleSendInvite = () => {
    if (!email) return;
    // Simulate sending invite
    setSent(true);
    setEmail('');
    setTimeout(() => setSent(false), 3000);
  };

  return (
    <div style={{ paddingBottom: '80px', minHeight: '100vh', background: 'linear-gradient(180deg, #2C1B13 0%, #1a0f0a 100%)' }}>
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        background: 'rgba(44, 27, 19, 0.95)',
        padding: '16px',
        borderBottom: '2px solid rgba(215, 181, 109, 0.3)',
        backdropFilter: 'blur(12px)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
      }}>
        <button
          onClick={() => navigate('/profile')}
          style={{
            background: 'none',
            border: 'none',
            color: '#E6D7C3',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '16px'
          }}
        >
          <ArrowLeft size={20} />
          Back to Profile
        </button>
      </div>

      <div style={{ padding: '32px 20px' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: 'linear-gradient(135deg, #D7B56D, #A57C33)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            boxShadow: '0 8px 24px rgba(215, 181, 109, 0.4)'
          }}>
            <Gift size={40} style={{ color: '#2C1B13' }} />
          </div>
          <h1 style={{
            fontSize: '32px',
            color: '#E6D7C3',
            fontFamily: 'Playfair Display, serif',
            marginBottom: '12px',
            textShadow: '0 2px 8px rgba(0, 0, 0, 0.5)'
          }}>
            Refer a Friend
          </h1>
          <p style={{
            color: '#A57C33',
            fontSize: '16px',
            lineHeight: '1.6',
            maxWidth: '400px',
            margin: '0 auto'
          }}>
            Invite your friends to join Near U's exclusive community and earn rewards
          </p>
        </div>

        {/* Rewards Section */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(215, 181, 109, 0.15), rgba(165, 124, 51, 0.1))',
          padding: '24px',
          borderRadius: '20px',
          marginBottom: '32px',
          border: '2px solid rgba(215, 181, 109, 0.3)',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '16px'
          }}>
            <Sparkles size={24} style={{ color: '#D7B56D' }} />
            <h2 style={{
              fontSize: '22px',
              color: '#D7B56D',
              fontFamily: 'Playfair Display, serif',
              margin: 0
            }}>
              Referral Rewards
            </h2>
          </div>
          <div style={{ display: 'grid', gap: '16px' }}>
            <div style={{
              background: 'rgba(44, 27, 19, 0.5)',
              padding: '16px',
              borderRadius: '12px',
              border: '1px solid rgba(215, 181, 109, 0.2)'
            }}>
              <div style={{ color: '#D7B56D', fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' }}>
                🎁 You Get
              </div>
              <div style={{ color: '#E6D7C3', fontSize: '14px' }}>
                1 month of Elite membership free when your friend joins
              </div>
            </div>
            <div style={{
              background: 'rgba(44, 27, 19, 0.5)',
              padding: '16px',
              borderRadius: '12px',
              border: '1px solid rgba(215, 181, 109, 0.2)'
            }}>
              <div style={{ color: '#D7B56D', fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' }}>
                💝 They Get
              </div>
              <div style={{ color: '#E6D7C3', fontSize: '14px' }}>
                50% off their first month of membership
              </div>
            </div>
          </div>
        </div>

        {/* Referral Code Section */}
        <div style={{
          background: 'rgba(215, 181, 109, 0.08)',
          padding: '24px',
          borderRadius: '20px',
          marginBottom: '24px',
          border: '2px solid rgba(215, 181, 109, 0.3)',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)'
        }}>
          <h3 style={{
            fontSize: '18px',
            color: '#D7B56D',
            marginBottom: '12px',
            fontFamily: 'Playfair Display, serif'
          }}>
            Your Referral Code
          </h3>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            background: 'rgba(44, 27, 19, 0.6)',
            padding: '16px',
            borderRadius: '12px',
            border: '1px solid rgba(215, 181, 109, 0.4)',
            marginBottom: '16px'
          }}>
            <div style={{
              flex: 1,
              color: '#E6D7C3',
              fontSize: '18px',
              fontWeight: 'bold',
              letterSpacing: '1px',
              fontFamily: 'monospace'
            }}>
              {referralCode}
            </div>
            <button
              onClick={handleCopy}
              style={{
                background: copied ? 'linear-gradient(135deg, #50C878, #2E8B57)' : 'linear-gradient(135deg, #D7B56D, #A57C33)',
                color: '#2C1B13',
                border: 'none',
                padding: '10px 16px',
                borderRadius: '10px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '14px',
                fontWeight: 'bold',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
              }}
            >
              {copied ? <Check size={18} /> : <Copy size={18} />}
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>

          <div style={{
            background: 'rgba(44, 27, 19, 0.6)',
            padding: '12px 16px',
            borderRadius: '12px',
            border: '1px solid rgba(215, 181, 109, 0.3)',
            marginBottom: '16px'
          }}>
            <div style={{ color: '#A57C33', fontSize: '12px', marginBottom: '4px' }}>
              Referral Link
            </div>
            <div style={{
              color: '#E6D7C3',
              fontSize: '13px',
              wordBreak: 'break-all'
            }}>
              {referralLink}
            </div>
          </div>

          <button
            onClick={handleShare}
            style={{
              width: '100%',
              background: 'linear-gradient(135deg, #D7B56D, #A57C33)',
              color: '#2C1B13',
              border: 'none',
              padding: '16px',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              boxShadow: '0 6px 20px rgba(215, 181, 109, 0.4)',
              transition: 'transform 0.2s ease'
            }}
            onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.98)'}
            onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <Share2 size={20} />
            Share Referral Link
          </button>
        </div>

        {/* Email Invite Section */}
        <div style={{
          background: 'rgba(215, 181, 109, 0.08)',
          padding: '24px',
          borderRadius: '20px',
          border: '2px solid rgba(215, 181, 109, 0.3)',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)'
        }}>
          <h3 style={{
            fontSize: '18px',
            color: '#D7B56D',
            marginBottom: '12px',
            fontFamily: 'Playfair Display, serif'
          }}>
            Invite by Email
          </h3>
          <p style={{
            color: '#A57C33',
            fontSize: '14px',
            marginBottom: '16px',
            lineHeight: '1.5'
          }}>
            Send a personal invitation directly to your friend's email
          </p>
          <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="friend@example.com"
              style={{
                flex: 1,
                padding: '14px 16px',
                background: 'rgba(44, 27, 19, 0.6)',
                border: '1px solid rgba(215, 181, 109, 0.4)',
                borderRadius: '12px',
                color: '#E6D7C3',
                fontSize: '15px'
              }}
            />
            <button
              onClick={handleSendInvite}
              disabled={!email || sent}
              style={{
                background: sent ? 'linear-gradient(135deg, #50C878, #2E8B57)' : 'linear-gradient(135deg, #D7B56D, #A57C33)',
                color: '#2C1B13',
                border: 'none',
                padding: '14px 20px',
                borderRadius: '12px',
                cursor: email && !sent ? 'pointer' : 'not-allowed',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '15px',
                fontWeight: 'bold',
                opacity: email && !sent ? 1 : 0.5,
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
              }}
            >
              {sent ? <Check size={18} /> : <Mail size={18} />}
              {sent ? 'Sent!' : 'Send'}
            </button>
          </div>
          {sent && (
            <div style={{
              color: '#50C878',
              fontSize: '13px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}>
              <Check size={16} />
              Invitation sent successfully!
            </div>
          )}
        </div>

        {/* Stats Section */}
        <div style={{
          marginTop: '32px',
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '16px'
        }}>
          <div style={{
            background: 'rgba(215, 181, 109, 0.08)',
            padding: '20px',
            borderRadius: '16px',
            textAlign: 'center',
            border: '1px solid rgba(215, 181, 109, 0.3)'
          }}>
            <div style={{
              fontSize: '32px',
              color: '#D7B56D',
              fontWeight: 'bold',
              marginBottom: '8px',
              fontFamily: 'Playfair Display, serif'
            }}>
              0
            </div>
            <div style={{ color: '#A57C33', fontSize: '13px' }}>
              Friends Invited
            </div>
          </div>
          <div style={{
            background: 'rgba(215, 181, 109, 0.08)',
            padding: '20px',
            borderRadius: '16px',
            textAlign: 'center',
            border: '1px solid rgba(215, 181, 109, 0.3)'
          }}>
            <div style={{
              fontSize: '32px',
              color: '#D7B56D',
              fontWeight: 'bold',
              marginBottom: '8px',
              fontFamily: 'Playfair Display, serif'
            }}>
              0
            </div>
            <div style={{ color: '#A57C33', fontSize: '13px' }}>
              Friends Joined
            </div>
          </div>
        </div>

        {/* How it Works */}
        <div style={{
          marginTop: '32px',
          background: 'rgba(106, 155, 216, 0.08)',
          padding: '24px',
          borderRadius: '20px',
          border: '1px solid rgba(106, 155, 216, 0.3)'
        }}>
          <h3 style={{
            fontSize: '18px',
            color: '#6A9BD8',
            marginBottom: '16px',
            fontFamily: 'Playfair Display, serif'
          }}>
            How It Works
          </h3>
          <ol style={{
            color: '#E6D7C3',
            fontSize: '14px',
            lineHeight: '1.8',
            paddingLeft: '20px',
            margin: 0
          }}>
            <li>Share your unique referral code or link with friends</li>
            <li>Your friend signs up using your code</li>
            <li>They get 50% off their first month</li>
            <li>You receive 1 month of Elite membership free!</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default ReferFriendPage;
